import React from 'react'
import CollapsableCard from '../../../common/card/CollapsableCard'

const AvailableContent = () => {
  return (
    <>
      <CollapsableCard title='Available Content'>
        Hello from Available Content
      </CollapsableCard>
    </>
  )
}

export default AvailableContent
